'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_presto$002etypes$0024$0024anon$002493 from "./presto.types$$anon$93.js";
import * as $j_presto$002etypes$0024$002dIp$002dPayload$0024 from "./presto.types$-Ip-Payload$.js";
import * as $j_presto$002etypes$0024$002dRule$002dKind$0024 from "./presto.types$-Rule-Kind$.js";
var $p;
/** @constructor */
function $c_Lpresto_types$Rule$$anon$92(outer) {
  this.cah = null;
  this.ca9 = null;
  this.caa = false;
  this.cai = null;
  this.caj = false;
  this.cam = null;
  this.caf = null;
  this.cag = false;
  this.cab = null;
  this.cac = false;
  this.cad = null;
  this.cae = false;
  this.cak = false;
  this.cal = false;
  if ((outer === null)) {
    throw $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$ct_jl_NullPointerException__(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_jl_NullPointerException());
  }
  this.cah = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_derivation_Configuration$().u;
  this.cam = "IpPayload";
}
export { $c_Lpresto_types$Rule$$anon$92 as $c_Lpresto_types$Rule$$anon$92 };
$p = $c_Lpresto_types$Rule$$anon$92.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_types$Rule$$anon$92;
/** @constructor */
function $h_Lpresto_types$Rule$$anon$92() {
}
export { $h_Lpresto_types$Rule$$anon$92 as $h_Lpresto_types$Rule$$anon$92 };
$h_Lpresto_types$Rule$$anon$92.prototype = $p;
$p.F = (function(c) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_Decoder__tryDecode__Lio_circe_ACursor__s_util_Either(this, c);
});
$p.J = (function() {
  return this.cah;
});
$p.L = (function() {
  if ((!this.caa)) {
    this.ca9 = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__constructorNames__sci_List(this);
    this.caa = true;
  }
  return this.ca9;
});
$p.O = (function() {
  if ((!this.caj)) {
    this.cai = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__io$circe$derivation$ConfiguredDecoder$$decodersDict__sci_Map(this);
    this.caj = true;
  }
  return this.cai;
});
$p.E = (function() {
  return this.cam;
});
$p.t = (function() {
  if ((!this.cag)) {
    this.caf = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("kind", new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("ip", $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$()));
    this.cag = true;
  }
  return this.caf;
});
$p.M = (function() {
  if ((!this.cac)) {
    this.cab = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon($j_presto$002etypes$0024$002dRule$002dKind$0024.$m_Lpresto_types$RuleKind$().SS(), new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Decoder$().aa, $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$()));
    this.cac = true;
  }
  return this.cab;
});
$p.Q = (function() {
  if ((!this.cae)) {
    this.cad = new $j_presto$002etypes$0024$0024anon$002493.$c_Lpresto_types$$anon$93();
    this.cae = true;
  }
  return this.cad;
});
$p.w = (function() {
  if ((!this.cal)) {
    this.cak = false;
    this.cal = true;
  }
  return this.cak;
});
$p.G = (function(c) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__decodeProduct__Lio_circe_HCursor__F1__s_util_Either(this, c, new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sjsr_AnonFunction1(((\u03b4scrutinee101) => ((p) => \u03b4scrutinee101.cGC(p)))($j_presto$002etypes$0024$002dIp$002dPayload$0024.$m_Lpresto_types$IpPayload$())));
});
var $d_Lpresto_types$Rule$$anon$92 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_types$Rule$$anon$92, "presto.types$Rule$$anon$92", ({
  a1d: 1,
  a: 1,
  f: 1,
  h: 1,
  d: 1
}));
export { $d_Lpresto_types$Rule$$anon$92 as $d_Lpresto_types$Rule$$anon$92 };
//# sourceMappingURL=presto.types$-Rule$$anon$92.js.map
